const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Anexos da Agenda voltam do backend como /api/agenda/attachments/{uuid}.ext
// (LUMIS não tem StaticFiles mount, é servido por rota própria — ver agenda.py)
export function getImageUrl(value) {
  if (!value || typeof value !== "string") return null;
  if (value.startsWith("http")) return value;
  return `${BACKEND}${value}`;
}
